// extracted by mini-css-extract-plugin
export default {"root":"ManageCreditSubmitButton_root__NUC6z"};